export default "__VITE_ASSET__B_V$ZyYR__"